import { Popover } from "antd-mobile"
import styled from "styled-components"

export const HomeBanner = styled.div`
  color: #fff;
`



export const StyledDay = styled.div`
  cursor: pointer;
  font-size: 20px;
  font-weight: 700;
  line-height: 120%;
`

export const SwitchCaloriesViewPopover = styled(Popover.Menu)<{
  $popoverInnerLeft: number
}>`
  --arrow-size: 0px;
  background: transparent;

  .adm-popover-inner {
    position: absolute;
    top: 5px;
    left: ${(props) => props.$popoverInnerLeft}px;

    border-radius: 8px;
    border: 1px solid var(--Primitive-White_20, rgba(255, 255, 255, 0.2));
    background: rgba(0, 34, 52, 0.33);

    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(24px);

    padding: 4px 16px;
  }

  .adm-popover-menu-item:active:not(.adm-popover-menu-item-disabled)::after {
    border-bottom: transparent;
  }

  .adm-popover-menu-item:active:not(.adm-popover-menu-item-disabled) {
    background: transparent;
  }

  .adm-popover-menu-item {
    padding-left: 0px;

    &:first-child {
      .adm-popover-menu-item-text {
        border-top: none;
      }
    }

    .adm-popover-menu-item-text {
      padding: 0;
      line-height: 22px;
      font-weight: 600;
      font-size: 14px;
    }
  }

  .adm-popover-menu-item-text {
    border-color: rgba(255, 255, 255, 0.2);
  }
`

export const ToggleCaloriesViewMenu = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 12px 0px;
`

export const ToggleCaloriesViewText = styled.div`
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0.14px;
  white-space: nowrap;
  color: var(--Schemes-On-Primary, #ffffff);
`

export const NavigateButton = styled.div`
  display: flex;
  width: 34px;
  height: 34px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const SwitchViewButton = styled.div<{ $isActive: boolean }>`
  margin-left: auto;
  display: flex;
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
  gap: 20px;
  border-radius: 100px;
  background: ${(props) =>
    props.$isActive
      ? "var(--Primitive-White_10, rgba(255, 255, 255, 0.10));"
      : "transparent"};
`

export const NavigationRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  position: relative;
  z-index: 1;
  padding: 0 24px;
`

export const NavigationLeft = styled.div<{ $width: number }>`
  display: flex;
  min-width: ${(props) => props.$width}px;
  max-width: ${(props) => props.$width}px;
  justify-content: space-between;
  align-items: center;
  margin-left: -5px;
`
